import { Box, CircularProgress, Typography } from '@mui/material';
import { pdfContainerSx } from './PdfSxs';
import {
  cardsCss,
  dataGraphsCss,
  newCardsCss
} from 'src/content/dashboard/DashboardCss';
import {
  formatNumberWithCommas,
  parseAsLocalDate,
  timeConverter
} from '../config/FunctionHelper';
import { cardsTexts } from 'src/content/dashboard/TextMessages';
import { RootState } from 'src/redux/store';
import { useSelector } from 'react-redux';
import { Area, AreaChart, ResponsiveContainer, Tooltip } from 'recharts';
export const PdfSecondCard = ({
  isPdfBuilder,
  reportMetaData
}: {
  isPdfBuilder?: boolean;
  reportMetaData?: any;
}) => {
  const pdfReportData = useSelector(
    (state: RootState) => state.dashboard.pdfReportData
  );

  const timeline = (pdfReportData as any)?.config?.timeline;

  const organicTraffic = pdfReportData?.organicTraffic;
  const graphMetrics = organicTraffic?.getClickOfMonth || [];

  const getOrganicSearchTrafficDetails = {
    organicSearchTraffic: organicTraffic?.totalClicksCurrentMonth,
    organicSearchDifference: organicTraffic?.clickDifferencePercentage,
    totalMonthOfTraffic: graphMetrics,
    compareStartDate: isPdfBuilder
      ? (timeline?.periodStartDate || 0) * 1000
      : organicTraffic?.compareStartDate,
    compareEndDate: isPdfBuilder
      ? (timeline?.periodEndDate || 0) * 1000
      : organicTraffic?.compareEndDate
  };

  const pdfReportDataLoader = useSelector(
    (state: RootState) => state.dashboard.pdfReportDataLoader
  );
  let compareDate =
    useSelector((state: RootState) => state.siteAudit?.compareDate) ?? 0;
  const currentDate = new Date().getTime();
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  const strokeColor =
    parseFloat(getOrganicSearchTrafficDetails?.organicSearchDifference || 0) < 0
      ? '#F45251'
      : '#25D3B1';
  const stopColorOne =
    parseFloat(getOrganicSearchTrafficDetails?.organicSearchDifference || 0) < 0
      ? 'rgba(217, 45, 32, 1)'
      : '#25D3B1';
  const stopColorTwo =
    parseFloat(getOrganicSearchTrafficDetails?.organicSearchDifference || 0) < 0
      ? 'rgba(217, 45, 32, 0)'
      : 'rgba(37, 211, 177, 0)';
  return (
    <>
      <Box
        sx={{
          ...pdfContainerSx?.pdfCardsSx,
          ...pdfContainerSx?.footerAlignBoxSx
        }}
      >
        <div>
          <p style={pdfContainerSx?.cardTitleStyles}>
            {'Organic Search Traffic'}
          </p>
          <Box>
            {pdfReportDataLoader && !pdfReportData ? (
              <Box sx={cardsCss?.loaderBox}>
                <CircularProgress
                  size={24}
                  color="inherit"
                  sx={newCardsCss?.circularLoadingSx}
                />
              </Box>
            ) : getOrganicSearchTrafficDetails &&
              typeof getOrganicSearchTrafficDetails?.organicSearchTraffic ===
                'number' ? (
              <Box sx={newCardsCss?.numBoxCss}>
                <Typography sx={{ ...cardsCss?.numTextCss, fontWeight: 680 }}>
                  {formatNumberWithCommas(
                    getOrganicSearchTrafficDetails?.organicSearchTraffic
                  )}
                </Typography>
                <Box sx={newCardsCss?.newIconBoxCss}>
                  {parseFloat(
                    getOrganicSearchTrafficDetails?.organicSearchDifference || 0
                  ) < 0 ? (
                    <>
                      {/*<TrendingDownIcon sx={newCardsCss?.trendingDownIconSx} />*/}
                      <img
                        src="/static/images/icons/red_down.svg"
                        alt="icon"
                        style={{
                          ...pdfContainerSx?.commonImgIconStyle,
                          objectFit: 'contain'
                        }}
                      />
                      <Typography
                        sx={{
                          ...cardsCss?.perSx,
                          ...newCardsCss?.perNewSx
                        }}
                      >
                        {getOrganicSearchTrafficDetails?.organicSearchDifference !=
                        null
                          ? `${getOrganicSearchTrafficDetails?.organicSearchDifference}%`
                          : ''}
                      </Typography>
                    </>
                  ) : getOrganicSearchTrafficDetails?.organicSearchDifference ? (
                    <>
                      <div
                        style={{
                          ...pdfContainerSx?.commonImgIconStyle,
                          height: 'auto'
                        }}
                      >
                        <img
                          src="/static/images/icons/green_up.svg"
                          alt="icon"
                          style={
                            {
                              //objectFit: 'contain'
                            }
                          }
                          //style={newCardsCss?.imgSx}
                        />
                      </div>
                      <Typography
                        sx={{
                          ...cardsCss?.perSx,
                          fontSize: '16px'
                        }}
                      >
                        {parseFloat(
                          getOrganicSearchTrafficDetails?.organicSearchDifference
                        )}
                        %
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Typography sx={newCardsCss?.noChangesSx}>
                        {cardsTexts?.noChanges}
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>
            ) : (
              <Box sx={cardsCss?.dashBox}>
                <Typography sx={cardsCss?.dashSx}>{'---'}</Typography>
              </Box>
            )}
          </Box>
          <Box sx={{ ...newCardsCss?.graphBoxSx, height: '120px' }}>
            {getOrganicSearchTrafficDetails &&
              typeof getOrganicSearchTrafficDetails?.organicSearchTraffic ===
                'number' && (
                <ResponsiveContainer>
                  <AreaChart
                    data={
                      getOrganicSearchTrafficDetails?.totalMonthOfTraffic || []
                    }
                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }} // Removes padding on all sides
                  >
                    {/* Define the equivalent linear gradient */}
                    <defs>
                      <linearGradient
                        id="customGradient"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        {/* Solid green at the bottom */}
                        <stop
                          offset="70%"
                          stopColor={stopColorOne}
                          stopOpacity={1}
                        />
                        {/* Transparent green at the top */}
                        <stop
                          offset="100%"
                          stopColor={stopColorTwo}
                          stopOpacity={1}
                        />
                      </linearGradient>
                    </defs>
                    {/* Tooltip Configuration */}
                    <Tooltip
                      content={({ payload }) => {
                        if (payload && payload.length > 0) {
                          const value = payload[0]?.value; // Get the clicked value
                          return (
                            <div
                              style={{
                                ...dataGraphsCss?.graphToolTipContent // Apply custom styles
                              }}
                            >
                              <span style={dataGraphsCss?.graphToolTipLabel}>
                                <b>Traffic:</b> {value}
                              </span>
                            </div>
                          );
                        }
                        return null;
                      }}
                      cursor={dataGraphsCss?.graphTooltipCursor}
                    />

                    {/* Area Chart */}
                    <Area
                      type="monotone"
                      dataKey="clicks" // Replace with the correct key from your data
                      stroke={strokeColor}
                      fill="url(#customGradient)"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              )}
          </Box>
        </div>
        {(compareDate !== 0 ||
          getOrganicSearchTrafficDetails?.compareStartDate !== 0) && (
          <div
            style={{
              textAlign: 'center',
              ...pdfContainerSx?.compareDateBoxSx,
              marginTop: '14px'
            }}
          >
            <p style={pdfContainerSx?.compareDateTextSx}>
              {timeConverter(
                parseAsLocalDate(getOrganicSearchTrafficDetails?.compareStartDate)?.getTime(),
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}
              {' - '}
              {` ${timeConverter(
                parseAsLocalDate(getOrganicSearchTrafficDetails?.compareEndDate)?.getTime(),
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}`}
              {compareDate !== 0 &&
                getOrganicSearchTrafficDetails?.compareEndDate &&
                getOrganicSearchTrafficDetails?.compareStartDate &&
                ' vs previous period'}
            </p>
          </div>
        )}
      </Box>
    </>
  );
};
